import { gql } from '@apollo/client';

/** mutation to create user comment for FR2052A rule */
export const CREATE_FFIEC041_USER_COMMENT = gql`
mutation createFFIEC041UserComment($input: CreateFFIEC041UserCommentInput) {
	createFFIEC041UserComment(input: $input)
}`;

/** mutation to update user comment for FR2052A rule */
export const UPDATE_FFIEC041_USER_COMMENT = gql`
mutation updateFFIEC041UserComment($input: UpdateFFIEC041UserCommentInput) {
	updateFFIEC041UserComment(input: $input)
}`;

export const DELETE_FFIEC041_USER_COMMENT = gql`
mutation deleteFFIEC041UserComment($input: DeleteFFIEC041UserCommentInput) {
	deleteFFIEC041UserComment(input: $input)
}`;

export const CREATE_CLASSIFY_AUDIT_LOGS_FOR_FFIEC041 = gql`
mutation createClassifyAuditLogForFFIEC041($input: ClassifyFFIEC041Input) {
	createClassifyAuditLogForFFIEC041(input: $input)
}`;
